module.exports = __webpack_public_path__ + "img/bb_g3_t_eyes-06.cdfcb3c4.svg";